export const CARD_AGREEMENT_PDF_URL = 'https://static-statusmoney.s3.us-west-2.amazonaws.com/files/Status+Money+Credit+Card+Agreement.pdf'
export const APPLICATION_TERMS_PDF_URL = 'https://static-statusmoney.s3.us-west-2.amazonaws.com/files/Credit+Card+Application+Terms+and+Conditions.pdf'
export const PRIVACY_NOTICE_PDF_URL = 'https://static-statusmoney.s3.us-west-2.amazonaws.com/files/Consumer+Privacy+Policy+Notice.pdf'
export const ECA_DOCUMENT_PDF_URL = 'https://static-statusmoney.s3.us-west-2.amazonaws.com/files/Evolve+Bank+%26+Trust+Electronic+Communication+Consent.pdf'

export const CC_SUPPORT_PHONE_NUMBER = '(844) 333-3110' as const

export const CC_ONBOARDING_STEP_ADDRESS = 'address' as const
export const CC_ONBOARDING_STEP_PHONE = 'phone' as const
export const CC_ONBOARDING_STEP_SSN = 'ssn' as const
export const CC_ONBOARDING_STEP_REVIEW = 'review' as const
export const CC_ONBOARDING_STEP_PENDING = 'pending' as const
export const CC_ONBOARDING_STEP_OFFER = 'offer' as const
export const CC_ONBOARDING_STEP_DECLINED = 'offer-declined' as const
export const CC_ONBOARDING_STEP_SUBMIT = 'submit' as const
export const CC_ONBOARDING_STEP_DENIED = 'denied' as const
export const CC_ONBOARDING_STEP_SUCCESS = 'success' as const

export const ccOnboardingAvailableSteps = new Set([
  CC_ONBOARDING_STEP_ADDRESS,
  CC_ONBOARDING_STEP_PHONE,
  CC_ONBOARDING_STEP_SSN,
  CC_ONBOARDING_STEP_REVIEW,
  CC_ONBOARDING_STEP_PENDING,
  CC_ONBOARDING_STEP_OFFER,
  CC_ONBOARDING_STEP_DECLINED,
  CC_ONBOARDING_STEP_SUBMIT,
  CC_ONBOARDING_STEP_DENIED,
  CC_ONBOARDING_STEP_SUCCESS,
])

export type CCOnboardingStep = Parameters<typeof ccOnboardingAvailableSteps['has']>[0]

export const CC_ONBOARDING_FIRST_STEP = CC_ONBOARDING_STEP_ADDRESS

export const CC_ONBOARDING_MAX_STEPS_AUTH = 3
export const CC_ONBOARDING_MAX_STEPS_UNAUTH = 5

export const CC_ONBOARDING_STATE_NOT_STARTED = 'not_started' as const // # Onboarding not started, person data may be changed
export const CC_ONBOARDING_STATE_CHECKING_ELIGIBILITY = 'checking_eligibility' as const // # Onboarding started, we are checking elibility
export const CC_ONBOARDING_STATE_OFFER_RECEIVED = 'offer_received' as const // # Credit pre-approved (show terms to member)
export const CC_ONBOARDING_STATE_CHECKING_CREDIT = 'checking_credit' as const // # Credit is being approved
export const CC_ONBOARDING_STATE_PREPARING_CARD = 'preparing_card' as const // # Card was approved and now is being delivered
export const CC_ONBOARDING_STATE_FINISHED = 'finished' as const // #
export const CC_ONBOARDING_STATE_FAILED = 'failed' as const // #

export const BALANCE_HINT = `This is the balance on the account, including any remaining balance from the last statement that closed. If you have any disputes under review for which adjustments have not been posted to your account, the disputed amount is included in this balance. It doesn't include any charges that are still pending. Paying your current balance may not pay your balance in full.`
export const AVAILABLE_CREDIT_HINT = `Your available credit is the amount of your credit line that you haven't used. Pending transactions are deducted from your available credit.`
export const STATEMENT_BALANCE_HINT = 'This is the total amount you owe from your most recent statement, adjusted for any payments or credits.'
export const MINIMUM_AMOUNT_DUE_HINT = 'This is the amount owed to satisfy your Minimum Payment Due. Your current Minimum Payment Due may not match your statement because of certain transactions that may have posted since your last statement.'
export const CREDIT_LIMIT_HINT = 'This is the total amount of your Credit Limit or Line as defined within your Cardmember Agreement.'
export const RECENT_TRANSACTIONS_HINT = 'The Recent Transactions you see include pending transactions and an estimated running balance'

export const RECENT_CARD_TRANSACTIONS_LIMIT = 8
